import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { customerApi } from "../lib/api";

const CustomerContext = createContext(null);

const TOKEN_KEY = "drift_customer_token";

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const setToken = (t) => {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  };

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setCustomer(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await customerApi.get("/customer/me");
      setCustomer(data);
    } catch {
      setToken(null);
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Skip /me while a Google callback is being processed (session_id in hash)
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refreshMe();
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await customerApi.post("/customer/login", { email, password });
    setToken(data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const register = async (email, password, name) => {
    const { data } = await customerApi.post("/customer/register", { email, password, name });
    setToken(data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const exchangeGoogle = async (sessionId) => {
    const { data } = await customerApi.post("/customer/google-session", { session_id: sessionId });
    setToken(data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const logout = () => {
    setToken(null);
    setCustomer(null);
  };

  return (
    <CustomerContext.Provider
      value={{ customer, loading, login, register, exchangeGoogle, logout, refreshMe }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = () => useContext(CustomerContext);
